var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"header"}},[_c('Header')],1),_c('Content'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }